import { featureEnabled } from "byzantine/src/Feature";
import type { Features } from "byzantine/src/Feature";

export type AchImportDefaultAction = "send" | "collect";

export const getAchImportDefaultAction = (
  features: Features
): AchImportDefaultAction => {
  const canSend = featureEnabled(features, {
    or: "indigo.ACHPaymentViaImport_permission",
  });
  const canCollect = featureEnabled(features, {
    or: "indigo.ACHPaymentCollectViaImport_permission",
  });

  return canCollect && !canSend ? "collect" : "send";
};
